import React from 'react';
import cn from 'classnames';
// Helpers
import { CommonInputProps, getCharacterCount } from 'helpers/input';
// Components
import { InputFooter } from 'ui3/InputFooter/InputFooter';
// Styles
import styles from './TextArea.module.scss';

type TextAreaProps = {
  name: string;
  id?: string;
  maxLength?: number;
  value?: string;
  rows?: number;
} & React.InputHTMLAttributes<HTMLTextAreaElement> &
  CommonInputProps;
const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(
  (
    {
      name,
      id = name,
      label,
      className,
      error,
      maxLength,
      value,
      rows = 3,
      onChange,
      hint,
      notice,
      disabled,
      ...restProps
    },
    ref
  ) => {
    const hasError = Boolean(error);
    const showCounter = maxLength !== undefined;
    const currentValue = value?.toString() || '';
    const currentLength = getCharacterCount(currentValue);

    const handleOnChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
      onChange && onChange(event);
    };

    const tooltipId = `textarea-tooltip-${id}`;

    return (
      <div className={cn(styles.root, className)}>
        {label && (
          <label htmlFor={id} className={styles.label}>
            {label}
          </label>
        )}
        <textarea
          ref={ref}
          name={name}
          id={id}
          className={cn(styles.textarea, {
            [styles.error]: hasError,
            [styles.disabled]: disabled,
          })}
          maxLength={maxLength}
          value={value}
          onChange={handleOnChange}
          rows={rows}
          disabled={disabled}
          {...restProps}
        />

        <InputFooter
          hint={hint}
          notice={notice}
          error={error}
          showCounter={showCounter}
          currentLength={currentLength}
          maxLength={maxLength}
          tooltipId={tooltipId}
        />
      </div>
    );
  }
);

TextArea.displayName = 'TextArea';

export default TextArea;
